import { Globe, Monitor, Box } from 'lucide-react';

/**
 * SDK Container Configuration
 * 
 * In production/Docker: Uses container name (sdk-container)
 * In development: Uses localhost with mapped port
 */
export const SDK_CONTAINER_NAME = 'millRun-frontend';
export const SDK_CONTAINER_PORT = 2521;

// Mill SDK frontend serves compiled IIFE bundles at /dist/{variant}_sdk/
const getSDKBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const envUrl = process.env.REACT_APP_SDK_BASE_URL;
    if (envUrl) {
      return envUrl;
    }
    return `http://localhost:${SDK_CONTAINER_PORT}/dist`;
  }
  return `http://${SDK_CONTAINER_NAME}:${SDK_CONTAINER_PORT}/dist`;
};

export const SDK_BASE_URL = getSDKBaseUrl();

/**
 * SDK Variant Configuration
 */
export const SDK_VARIANTS = [
  {
    id: 'web_sdk',
    name: 'Web SDK',
    description: 'Build plugins for Silo\'s web interface',
    icon: Globe,
    path: '/web_sdk',
    runtimeConfig: {
      backendEnabled: true,
      httpBaseUrl: '/mill',
      wsBaseUrl: null // derived at runtime from origin + /mill
    }
  },
  {
    id: 'desktop_sdk',
    name: 'Desktop SDK',
    description: 'Build desktop applications with Silo integration',
    icon: Monitor,
    path: '/desktop_sdk',
    runtimeConfig: {
      backendEnabled: true,
      httpBaseUrl: '/mill',
      wsBaseUrl: null
    }
  },
  {
    id: 'dcc_sdk',
    name: 'DCC SDK',
    description: 'Build plugins for DCC applications (Maya, Nuke, etc.)',
    icon: Box,
    path: '/dcc_sdk',
    runtimeConfig: {
      backendEnabled: true,
      httpBaseUrl: '/mill',
      wsBaseUrl: null
    }
  }
];

/**
 * Build bundle URL for a variant
 * @param {Object} variant - SDK variant config
 * @returns {string} Full bundle URL
 */
export function getBundleUrl(variant) {
  return `${SDK_BASE_URL}${variant.path}`;
}

